module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.l = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// identity function for calling harmory imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };

/******/ 	// define getter function for harmory exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		Object.defineProperty(exports, name, {
/******/ 			configurable: false,
/******/ 			enumerable: true,
/******/ 			get: getter
/******/ 		});
/******/ 	};

/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};

/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 210);
/******/ })
/************************************************************************/
/******/ ({

/***/ 102:
/***/ function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ },

/***/ 132:
/***/ function(module, exports, __webpack_require__) {

var __vue_exports__, __vue_options__

/* styles */
__webpack_require__(102)

/* script */
__vue_exports__ = __webpack_require__(54)

/* template */
var __vue_template__ = __webpack_require__(172)
__vue_options__ = __vue_exports__ = __vue_exports__ || {}
if (
  typeof __vue_exports__.default === "object" ||
  typeof __vue_exports__.default === "function"
) {
__vue_options__ = __vue_exports__ = __vue_exports__.default
}
if (typeof __vue_options__ === "function") {
  __vue_options__ = __vue_options__.options
}

__vue_options__.render = __vue_template__.render
__vue_options__.staticRenderFns = __vue_template__.staticRenderFns

module.exports = __vue_exports__


/***/ },

/***/ 15:
/***/ function(module, exports) {

module.exports = require("mint-ui/lib/font/style.css");

/***/ },

/***/ 172:
/***/ function(module, exports) {

module.exports={render:function (){with(this) {
  return _h('a', {
    staticClass: "mint-cell",
    attrs: {
      "href": href
    }
  }, [(isLink) ? _h('span', {
    staticClass: "mint-cell-mask"
  }) : _e(), " ", _h('div', {
    staticClass: "mint-cell-left"
  }, [_t("left")]), " ", _h('div', {
    staticClass: "mint-cell-wrapper"
  }, [_h('div', {
    staticClass: "mint-cell-title"
  }, [_t("icon", [(icon) ? _h('i', {
    staticClass: "mintui",
    class: 'mintui-' + icon
  }) : _e()]), " ", _t("title", [_h('span', {
    staticClass: "mint-cell-text",
    domProps: {
      "textContent": _s(title)
    }
  }), " ", (label) ? _h('span', {
    staticClass: "mint-cell-label",
    domProps: {
      "textContent": _s(label)
    }
  }) : _e()])]), " ", _h('div', {
    staticClass: "mint-cell-value",
    class: {
      'is-link': isLink
    }
  }, [_t("default", [_h('span', {
    domProps: {
      "textContent": _s(value)
    }
  })])])]), " ", _h('div', {
    staticClass: "mint-cell-right"
  }, [_t("right")]), " ", (isLink) ? _h('i', {
    staticClass: "mint-cell-allow-right"
  }) : _e()])
}},staticRenderFns: []}

/***/ },

/***/ 20:
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_cell_vue__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_cell_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_cell_vue__);

module.exports = __WEBPACK_IMPORTED_MODULE_0__src_cell_vue___default.a;


/***/ },

/***/ 210:
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(20);


/***/ },

/***/ 54:
/***/ function(module, exports, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

if (true) {
  __webpack_require__(15);
}

function cleanPath(path) {
  return path.replace(/\/\//g, '/');
}

/**
 * mt-cell
 * @module components/cell
 * @desc 单元格
 * @param {string} [to] - 跳转链接
 * @param {string} [icon] - 图标，提供 more, back，或者自定义的图标（传入不带前缀的图标类名，最后拼接成 .mintui-xxx）
 * @param {string} [title] - 标题
 * @param {string} [label] - 备注信息
 * @param {boolean} [is-link=false] - 可点击的链接
 * @param {string} [value] - 右侧显示文字
 * @param {slot} - 同 value, 会覆盖 value 属性
 * @param {slot} [title] - 同 title, 会覆盖 title 属性
 * @param {slot} [icon] - 同 icon, 会覆盖 icon 属性，例如可以传入图片
 *
 * @example
 * <mt-cell title="标题文字" icon="back" is-link value="描述文字"></mt-cell>
 * <mt-cell title="标题文字" icon="back">
 *   <div slot="value">描述文字啊哈</div>
 * </mt-cell>
 */
/* harmony default export */ exports["default"] = {
  name: 'mt-cell',

  props: {
    to: String,
    icon: String,
    title: String,
    label: String,
    isLink: Boolean,
    value: {}
  },

  computed: {
    href: function href() {
      var this$1 = this;

      var href;

      if (this.$router && this.to) {
        var base = this.$router.history.base;
        var resolved = this.$router.match(this.to);
        var fullPath = resolved.redirectedFrom || resolved.fullPath;

        href = base ? cleanPath(base + fullPath) : fullPath;
      } else {
        href = this.to;
      }

      if (href && !this.added && this.$router) {
        this.$nextTick(function () {
          this$1.added = true;
          this$1.$el.addEventListener('click', this$1.handleClick);
        });
      }
      return href;
    }
  },

  methods: {
    handleClick: function handleClick($event) {
      $event.preventDefault();
      this.$router.push(this.href);
    }
  }
};


/***/ }

/******/ });


//////////////////
// WEBPACK FOOTER
// ./~/.2.0.5@mint-ui/lib/cell/index.js
// module id = 229
// module chunks = 2